<cv-public-record-field [fieldOptions]="fieldOptions"
                        [values]="values">
</cv-public-record-field>